import {gql} from "@apollo/client";

// Global report list (/riskAssessmentReports). The report subgraph only stores
// the client and node IDs — selecting anything beyond `id` on those relations
// makes the gateway resolve them in the installedBase subgraph, and a single
// deleted client/node then errors the non-null field and nulls the whole list.
// Names are therefore looked up separately per page (useReportContextLookup).
// The backend returns only reports the user may access.
// NOTE: do not select createdBy — the subgraph currently answers any
// createdBy selection with an internal server error (backend in development).
export const RiskAssessmentReportGlobalList = gql`
    query RiskAssessmentReportGlobalList($filter: RiskAssessmentReportListFilter, $pagination: Pagination) {
        riskAssessmentReportList(filter: $filter) {
            total
            riskAssessmentReports(pagination: $pagination) {
                id
                title
                status
                reportType
                startDate
                endDate
                insert
                installedBaseNode {
                    id
                }
                client {
                    id
                }
            }
        }
    }
`;
